<div class="session-authentication-event" data-testid="inbox-ui-session-authentication-event">
    @if (event.eventType === eventType.escalationRequested) {
        <span data-testid="inbox-ui-session-authentication-event-text">
            {{ 'Higher authentication requested' | translate }}
        </span>
        @if (event.user?.name) {
            <span data-testid="inbox-ui-session-authentication-event-user">
                {{ 'by' | translate }} {{ event.user.name }}</span
            >
        }
    } @else {
        <span data-testid="inbox-ui-session-authentication-event-text">
            {{ 'Authentication updated' | translate }}: {{ levelLabel }}
        </span>
    }

    <small data-testid="inbox-ui-session-authentication-event-time">{{
        event.creationTime | date: 'dd.MM.yyyy HH:mm'
    }}</small>
</div>
